export type GlobalAddressResult = {
    header: {
        validatorService: string;
        timestamp: string;
    };
    addresses?: GlobalAddress[];
    error?: {
        code: string;
        message: string;
        source: string;
    };
    address?: GlobalAddress;
};

export type GlobalAddress = {
    id: string;
    address1: string;
    address2: string;
    city: string;
    region: string;
    postalCode: string;
    country: string;
    district?: string;
    extra?: ExtraFields;
    searchRef?: string;
};

type ExtraFields = {
    message: string;
    possibleMatches: number;
    fullAddress: string;
    englishAddress: string;
};

export enum GlobalAddressMode {
    LIST = "list",
    VALIDATE = null,
}
